<template>
  <div id="app" :data-lang="lang">
    <template v-if="isDataLoad">
      <transition :name="transitionName">
        <router-view class="my-router"></router-view>
      </transition>
      <EuPolicyAlert
        :show.sync="euPolicyShow"
        :content="euPolicyContent"
        :storageText="euPolicyChoiceContent.storageText"
        :adText="euPolicyChoiceContent.adText"
      ></EuPolicyAlert>
    </template>
  </div>
</template>

<script>
import ga from '@/utils/ga'
import utils from '@/utils/common.js'
import EuPolicyAlert from './components/base/EuPolicyAlert.vue'
import { euPopupInject } from './utils/eu_popup'

export default {
  name: 'App',
  components: {
    EuPolicyAlert,
  },
  watch: {
    isDataLoad() {
      console.log('====全局配置数据====')
      console.log(this.globalConfig)
      this.euPopupInject(this.globalConfig)
      this.lang = this.globalConfig.common_config.lang
    },
    //监听路由变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态，默认上下
      if (
        !to.meta ||
        !to.meta.index ||
        !from.meta ||
        !from.meta.index ||
        to.meta.index.toString().indexOf('-') > -1 ||
        from.meta.index.toString().indexOf('-') > -1
      ) {
        this.transitionName = ''
      } else {
        if (to.meta.index > from.meta.index) {
          //设置动画名称
          this.transitionName = 'slide-left'
        } else {
          this.transitionName = 'slide-right'
        }
      }
    },
  },
  data() {
    return {
      lang: '',
      transitionName: 'slide-bottom',
      isDataLoad: null,
      euPolicyShow: false,
      euPolicyContent: '',
      euPolicyChoiceContent: {
        storageText: '',
        adText: '',
      },
    }
  },
  created() {
    // checkUserAgent()
  },
  computed: {
    // 获取语言和token
    // lang () {
    //   return this.$route.query.lang || window.sessionStorage.getItem('Lang') || utils.getLang()
    // },
    accessToken() {
      return this.$route.query.access_token || window.sessionStorage.getItem('AccessToken') || ''
    },
    region() {
      return this.$route.query.region || window.sessionStorage.getItem('Region')
    },
  },
  mounted() {
    this.lang = this.$route.query.lang || window.sessionStorage.getItem('Lang')
    // 配置和用户初始化
    ga.sendThis(this)
    ga.getRegionLang(this.region, this.lang)
    ga.gaConfig(this.accessToken, this.lang, this.region)
  },
  methods: { euPopupInject },
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}
.my-router {
  position: absolute;
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue